
import AnimatedPage from "@/components/AnimatedPage";
import LoanForm from "@/components/LoanForm";
import NavHeader from "@/components/NavHeader";

const CreateLoan = () => {
  return (
    <AnimatedPage>
      <div className="container max-w-3xl py-8 space-y-8">
        <NavHeader
          title="Create Loan"
          subtitle="Add a new loan with customer details"
          backTo="/loans"
        />
        
        <div className="rounded-lg border bg-card p-6 shadow-sm">
          <LoanForm />
        </div>
      </div>
    </AnimatedPage>
  );
};

export default CreateLoan;
